import React, { useMemo } from 'react';
import { BackgroundImage, Container, Stacker, Styler } from '@honeycomb/ui-core';
import { CarouselDisplayStyle } from '@honeycomb/data';
import { GenericCardCarousel, SectionHeading, useResolveCMSColors } from '../../content';
import { GenericRootComponentContext, } from '../../content/GenericRootComponent/GenericRootComponent.context';
export function SimilarHotels({ similarHotelsDetails }) {
    const { sectionHeading, carousel, backgroundColor: backgroundColorCMS, backgroundImage } = similarHotelsDetails;
    const { backgroundColor, textColor, isBackgroundDark } = useResolveCMSColors({
        backgroundColorCMS: backgroundColorCMS || undefined,
    });
    // We are emulating a generic root component so that child components have the expected context.
    const contextValues = useMemo(() => {
        return {
            backgroundColor,
            textColor,
            isBackgroundDark,
            carouselDisplayStyle: CarouselDisplayStyle.Default,
        };
    }, [backgroundColor, isBackgroundDark, textColor]);
    if (!carousel) {
        return null;
    }
    return (React.createElement(GenericRootComponentContext.Provider, { value: contextValues },
        React.createElement(Styler, { overflow: "hidden", mt: 10, bg: backgroundColor },
            React.createElement(BackgroundImage, Object.assign({ component: "div" }, backgroundImage, { py: 10 }),
                React.createElement(Container, null,
                    React.createElement(Stacker, null,
                        (sectionHeading === null || sectionHeading === void 0 ? void 0 : sectionHeading.heading) && (React.createElement(SectionHeading, { alias: "similar-hotels-heading", sectionHeading: sectionHeading })),
                        React.createElement(GenericCardCarousel, { carousel: carousel })))))));
}
